import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=51dbc8dc&"
import script from "./BaseTitle.vue?vue&type=script&lang=js&"
export * from "./BaseTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports